export const RAID_PRACTICE_ACTION_LABELS = Object.freeze({
  add: '슬롯 추가',
  detail: '상세정보',
  edit: '수정',
  remove: '삭제',
  save: '저장',
  close: '닫기',
});

export function practiceActionStatus(label, working) {
  return working ? label + ' 중…' : label;
}

export function practiceSlotDeleteConfirmation(slotNo) {
  return (Number(slotNo) || 1) + '번 모의전 슬롯을 삭제할까요?';
}
